import type { Metric } from '../types.tsx';
import messages from './messages.tsx';

export const PROJECT_ROLE_ACTOR_KEY = 'projectroleactor';

export const PROJECT_ROLE_ACTOR: Metric = {
	key: PROJECT_ROLE_ACTOR_KEY,
	visible: true,
	name: messages.name,
	description: messages.description,
	tabLabels: [messages.analysis, messages.activityLog],
	warningMessage: messages.warning,
	exceededMessage: messages.exceeded,
	risks: [messages.risk1],
	mitigations: [messages.mitigation1, messages.mitigation2, messages.mitigation3],
	currentValueLabel: messages.currentValueLabel,
	currentValueAriaLabel: messages.currentValueAriaLabel,
	thresholdValueLabel: messages.thresholdValueLabel,
	thresholdValueAriaLabel: messages.thresholdValueAriaLabel,
	recommendationUrl:
		'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
	recommendationUrlText: messages.recommendationUrlText,
	graphHeader: messages.graphHeader,
};
